import { NOTIFICATION_TYPES } from "../getStockPageSectionFromNotificationType";

export const SID_NOTIFICATION_TYPES = [
  NOTIFICATION_TYPES.HIGHS_AND_LOWS_CORRECTION,
  NOTIFICATION_TYPES.HIGHS_AND_LOWS_SUMMARY,
  NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS
];

export const SID_LATEST_NOTIFICATIONS_LIMIT = 4;

export const SID_NOTIFICATIONS_TAB_NAME = "Strategies";

export const isSidNotificationType = notificationType =>
  SID_NOTIFICATION_TYPES.includes(notificationType);
